<template>
  <div class="Hblbox">
    <!-- <div class="Hblbox_l">
                  <img src="../../assets/pc/seach/1.png" />
                </div> -->
    <div class="Hblbox_r rights">
      <div class="Hblbox_title">
        To the next bonus era
        <el-tooltip placement="right" popper-class="toolTipClass">
          <div slot="content">
            In the TTOS blockchain, an "era" is defined as an<br />
            incentive cycle lasting 24 hours, during which<br />
            validators must claim their rewards within the
            <br />following 24 hours after the era concludes.<br />
            Rewards not claimed within this 24-hour<br />
            timeframe will be considered invalid.
          </div>
          <img src="../../assets/pc/Index/tip.png" />
        </el-tooltip>
        <!-- <img
                      src="../../assets/pc/Index/tip.png"
                    /> -->
      </div>
      <div class="Hblbox_content">
        {{ theTime2 }} h {{ theTime1 }} m {{ theTime }} s
      </div>
      <div class="Hblbox_bott">
        <div class="progress">
          <el-progress
            type="line"
            :percentage="Number(percentage)"
            class="el-bg-inner-running"
          ></el-progress>
        </div>
        <!-- <div class="boxnum">+2355555</div>
                    <div class="boxtit">Last 24h</div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["nextDuring"],
  data() {
    return {
      value: "",
      // 倒计时开始
    
      theTime: 0, // 秒
      theTime1: 0, // 分
      theTime2: 0, // 时
      percentage: "", //进度条倒计时
      // 倒计时结束
    };
  },
  watch: {
    deep: true,
    nextDuring(val) {
      this.nextDuring = val;
      // 
    },

    //
  },
  created() {},
  mounted() {
 this.daojishi();
  },
  methods: {
    daojishi() {
      this.Time = setInterval(async () => {
        this.nextDuring--;
        this.percentage = (((86400 - this.nextDuring) / 86400) * 100).toFixed(
          1
        );
        this.theTime = parseInt(this.nextDuring); // 需要转换的时间秒
        this.theTime1 = 0; // 分
        this.theTime2 = 0; // 小时
        if (this.theTime > 60) {
          this.theTime1 = parseInt(this.theTime / 60);
          if (this.theTime > 1) {
            this.theTime = parseInt(this.theTime % 60);
          } else {
            this.theTime = 60;
          }
          if (this.theTime1 > 60) {
            this.theTime2 = parseInt(this.theTime1 / 60);
            if (this.theTime1 > 1) {
              this.theTime1 = parseInt(this.theTime1 % 60);
            } else {
              this.theTime1 = 60;
            }
            if (this.theTime2 > 24) {
              //大于24小时
              this.theTime2 = parseInt(this.theTime2 % 24);
            }
          }
        }
      }, 1000);
    //  this.$emit("recordsChange",  this.nextDuring);
    },
  },
};
</script>

<style scoped>
.progress {
  width: 188px;
}
.el-progress {
  display: flex;
  margin-top: 4px;
}

.progress ::v-deep.el-progress-bar__outer {
  border-radius: 6px !important;
  border: none;
  width: 190px;
  height: 12px !important;
  background: #13161b;
  opacity: 1;
  margin-left: 0px !important;
}

.progress ::v-deep .el-bg-inner-running .el-progress-bar__inner {
  border-radius: 0px 6px 6px 0px;
  background-color: unset;
  height: 12px;
  background-image: linear-gradient(to right, #00e79a, #00e79a);
}
</style>
<style lang="less" scoped>
.Hblbox {
  width: 230px;
  height: 126px;
  background: #000000;
  border-radius: 20px 20px 20px 20px;
  opacity: 1;
  display: flex;

  margin-bottom: 20px;
  .Hblbox_l {
    margin-right: 10px;
    img {
      margin-top: 20px;
      margin-left: 20px;
      width: 46px;
      height: 46px;
    }
  }
  .rights {
    margin-left: 20px;
  }
  .Hblbox_r {
    .Hblbox_title {
      margin-top: 20px;
      height: 17px;
      font-size: 12px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.5);
      line-height: 17px;
      img {
        width: 13px;
        height: 13px;
        margin-left: 5px;
        margin-top: 5px;
      }
    }
    .Hblbox_content {
      height: 29px;
      font-size: 20px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 29px;
      margin-top: 4px;
    }
    .Hblbox_bott {
      display: flex;
      margin-top: 12px;
      .boxnum {
        height: 20px;
        font-size: 14px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #00e79a;
        line-height: 20px;
      }
      .boxtit {
        margin-left: 12px;
        height: 17px;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.5);
        line-height: 17px;
      }
    }
  }
}
</style>
